import withErrorBoundary from 'components/shared/withErrorBoundary';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface TicketBaggagePopupProps {
  outbond: any;
}

const TicketBaggagePopup: FC<TicketBaggagePopupProps> = ({ outbond }) => {
  const { t } = useTranslation();

  const isRedHandbag =
    !outbond.listOfFlyBaggagePrice || outbond.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag === 0;
  const isRedTrolley =
    !outbond.listOfFlyBaggagePrice || outbond.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley === 0;
  const isGreenTotal =
    outbond.listOfFlyBaggagePrice &&
    (outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight > 0 ||
      outbond.listOfFlyBaggagePrice?.[0]?.pieces > 0);

  return (
    <div className="ticket-baggage-popup">
      {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag !== -1 && (
        <div className="mb-5">
          {isRedHandbag ? (
            <span className="color-danger">{t('flight.handbag_excluded')}</span>
          ) : (
            <span className="text-success">
              {t('flight.handbag_included')} {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag}
              {t('kg')}
            </span>
          )}
        </div>
      )}
      {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley !== -1 && (
        <div className="mb-5">
          {isRedTrolley ? (
            <span className="color-danger">{t('flight.trolley_excluded')}</span>
          ) : (
            <span className="text-success">
              {t('flight.trolley_included')}
              {outbond.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley}
              {t('kg')}
            </span>
          )}
        </div>
      )}
      {outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight !== -1 && (
        <div className="mb-5">
          {isGreenTotal ? (
            <span className="text-success">
              {t('flight.bag_included')}
              {!!outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight && (
                <span>
                  {outbond.listOfFlyBaggagePrice?.[0]?.maxTotalWeight}
                  {t('kg')}
                </span>
              )}
            </span>
          ) : (
            <span className="color-danger">{t('flight.bag_excluded')}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(TicketBaggagePopup, 'TicketBaggagePopup');
